import { useRef, useState } from 'react';
import { A11y, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import type { Swiper as SwiperRef } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import styles from './TestimonialSlider.module.scss';
import { UI_TestimonialSliderItem, UI_TestimonialSliderItemProps } from './TestimonialSliderItem/TestimonialSliderItem';

export interface UI_TestimonialSliderProps {
	className?: string;
	slides?: UI_TestimonialSliderItemProps[];
}

export const UI_TestimonialSlider = ({ className, slides }: UI_TestimonialSliderProps) => {
	const swiperInstanceRef = useRef<SwiperRef | null>(null);
	const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);
	const [isBeginning, setIsBeginning] = useState<boolean>(true);
	const [isEnd, setIsEnd] = useState<boolean>((slides?.length ?? 0) <= 1);
	const updateEdgeState = (swiper: SwiperRef) => {
		setIsBeginning(swiper.isBeginning);
		setIsEnd(swiper.isEnd);
	};
	const handleSlideChange = (swiper: SwiperRef) => {
		setActiveSlideIndex(swiper.realIndex);
		updateEdgeState(swiper);
	};
	if (!slides?.length) return null;
	const hasMultipleSlides = slides.length > 1;
	const handlePrevClick = () => swiperInstanceRef.current?.slidePrev();
	const handleNextClick = () => swiperInstanceRef.current?.slideNext();

	return (
		<div className={classNames(styles.TestimonialSlider, className)}>
			<Swiper
				modules={[A11y, EffectFade]}
				slidesPerView={1}
				spaceBetween={0}
				autoHeight
				effect="fade"
				fadeEffect={{ crossFade: true }}
				onSlideChange={handleSlideChange}
				onSwiper={(swiper) => {
					swiperInstanceRef.current = swiper;
					updateEdgeState(swiper);
				}}
				className={classNames(styles.TestimonialSlider, styles[`u-color___${slides[activeSlideIndex]?.bgColor}`])}
			>
				{slides.map((slide, index, arr) => (
					<SwiperSlide key={index}>
						<UI_TestimonialSliderItem
							{...slide}
							slideNumber={arr.length}
							onHandlePrevClick={hasMultipleSlides ? handlePrevClick : undefined}
							onHandleNextClick={hasMultipleSlides ? handleNextClick : undefined}
							disablePrevButton={isBeginning}
							disableNextButton={isEnd}
							isActive={index === activeSlideIndex}
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};
